/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CardView extends Component {
	render() {
		return (
			<div
				className="cardThumbnails__item"
				dangerouslySetInnerHTML={{
					__html: this.props.thumbnail.data
				}}
			/>
		);
	}
}

CardView.propTypes = {
	thumbnail: PropTypes.shape({
		data: PropTypes.string
	})
};

export default CardView;



// WEBPACK FOOTER //
// ./src/js/components/cards/views/CardView.js